import { ArticleMeta } from './types';

// Tous les articles du blog. Un article s'ajoute ici, dans content/<slug>.ts et
// dans server/utils/seoPages.ts (titre et description, vérifiés au pré-rendu).
export const ARTICLES: ArticleMeta[] = [
  // ---- Préparer le mariage ----
  {
    slug: 'dossier-mariage-mairie',
    theme: 'preparer',
    label: 'Dossier de mariage en mairie',
    title: 'Dossier de mariage en mairie : pièces et délais',
    card: 'Les pièces à fournir, les témoins, la publication des bans et le calendrier.',
    seoTitle: 'Dossier de mariage en mairie : pièces à fournir et délais · RSVP Please',
  },
  {
    slug: 'checklist-mariage',
    theme: 'preparer',
    label: 'Checklist mariage',
    title: 'Checklist mariage : tout ce qu’il ne faut pas oublier',
    card: 'La liste complète, rangée par thème, à cocher jusqu’au jour J.',
    seoTitle: 'Checklist mariage complète : la liste à cocher, thème par thème · RSVP Please',
  },
  {
    slug: 'application-organisation-mariage',
    theme: 'preparer',
    label: 'Application mariage',
    title: 'Quelle application pour organiser son mariage ?',
    card: 'Ce qu’une bonne appli doit faire, les pièges à éviter, et notre méthode pour choisir.',
    seoTitle: 'Application pour organiser son mariage : comment bien choisir · RSVP Please',
  },
  {
    slug: 'mariage-vendredi',
    theme: 'preparer',
    label: 'Se marier un vendredi',
    title: 'Se marier un vendredi : ce qu’on économise vraiment',
    card: 'Les économies, les inconvénients pour les invités, et comment bien l’organiser.',
    seoTitle: 'Mariage un vendredi : économies, avantages et inconvénients · RSVP Please',
  },
  {
    slug: 'mariage-en-hiver',
    theme: 'preparer',
    label: 'Mariage en hiver',
    title: 'Mariage en hiver : idées, budget et organisation',
    card: 'Pourquoi c’est moins cher, les idées de déco et de menu, et les pièges du froid.',
    seoTitle: 'Mariage en hiver : idées, déco, budget et conseils · RSVP Please',
  },
  {
    slug: 'tendances-mariage-2027',
    theme: 'preparer',
    label: 'Tendances mariage 2027',
    title: 'Tendances mariage 2027',
    card: 'Les envies des couples pour 2027 : déco, invitations, réception et jour J.',
    seoTitle: 'Tendances mariage 2027 : déco, faire-part, réception · RSVP Please',
  },
  {
    slug: 'renouvellement-de-voeux',
    theme: 'preparer',
    label: 'Renouvellement de vœux',
    title: 'Renouvellement de vœux : l’organiser et l’écrire',
    card: 'Ce que ça implique, qui officie, le déroulé, et des textes pour l’invitation et les vœux.',
    seoTitle: 'Renouvellement de vœux : organisation, cérémonie et textes · RSVP Please',
  },
  {
    slug: 'nombre-invites-mariage',
    theme: 'preparer',
    label: 'Nombre d’invités',
    title: 'Combien d’invités pour un mariage ?',
    card: 'Le nombre moyen, ce que coûte chaque invité, et la méthode pour trouver votre chiffre.',
    seoTitle: 'Nombre moyen d’invités à un mariage : combien en inviter ? · RSVP Please',
  },
  {
    slug: 'date-mariage-2027',
    theme: 'preparer',
    label: 'Date mariage 2027',
    title: 'Quelle date pour se marier en 2027 ?',
    card: 'Les week-ends prolongés, les jours fériés, les dates symboliques et quand réserver.',
    seoTitle: 'Date mariage 2027 : jours fériés, ponts et dates symboliques · RSVP Please',
  },

  // ---- Budget et prix ----
  {
    slug: 'mariage-petit-budget',
    theme: 'budget',
    label: 'Mariage petit budget',
    title: 'Mariage petit budget : réussir avec 5 000 à 10 000 €',
    card: 'Un budget type, les postes à sacrifier ou pas, et 12 idées concrètes.',
    seoTitle: 'Mariage petit budget : organiser un beau mariage avec 5 000 € · RSVP Please',
  },
  {
    slug: 'prix-traiteur-mariage',
    theme: 'budget',
    label: 'Prix traiteur mariage',
    title: 'Prix d’un traiteur de mariage par personne',
    card: 'Les fourchettes par formule, ce qui est compris ou pas, et comment comparer les devis.',
    seoTitle: 'Prix traiteur mariage par personne : tarifs et devis · RSVP Please',
  },
  {
    slug: 'prix-photographe-mariage',
    theme: 'budget',
    label: 'Prix photographe mariage',
    title: 'Prix d’un photographe de mariage',
    card: 'Les tarifs selon la formule, ce que comprend le prix et les questions à poser.',
    seoTitle: 'Prix photographe mariage : combien ça coûte et ce qui est inclus · RSVP Please',
  },
  {
    slug: 'prix-dj-mariage',
    theme: 'budget',
    label: 'Prix DJ mariage',
    title: 'Prix d’un DJ de mariage',
    card: 'Combien coûte un DJ, ce que le tarif inclut, et les options qui font grimper la note.',
    seoTitle: 'Prix DJ mariage : tarifs, options et conseils pour choisir · RSVP Please',
  },
  {
    slug: 'prix-wedding-planner',
    theme: 'budget',
    label: 'Prix wedding planner',
    title: 'Prix d’un wedding planner, et comment s’en passer',
    card: 'Les formules et leur prix, ce qu’elles comprennent, et l’alternative à deux.',
    seoTitle: 'Prix wedding planner : tarifs des formules et alternatives · RSVP Please',
  },
  {
    slug: 'wedding-planner-lyon',
    theme: 'budget',
    label: 'Wedding planner Lyon',
    title: 'Wedding planner à Lyon : prix, rôle, et comment s’en passer',
    card: 'Ce qu’il coûte, les chiffres des mariages dans le Rhône, et l’alternative gratuite.',
    seoTitle: 'Wedding planner Lyon : prix, chiffres et alternatives · RSVP Please',
  },
  {
    slug: 'prix-robe-de-mariee',
    theme: 'budget',
    label: 'Prix robe de mariée',
    title: 'Prix d’une robe de mariée',
    card: 'Les prix selon où l’acheter, les frais qu’on oublie, et comment payer moins cher.',
    seoTitle: 'Prix robe de mariée : combien coûte une robe et les frais en plus · RSVP Please',
  },
  {
    slug: 'prix-fleuriste-mariage',
    theme: 'budget',
    label: 'Prix fleuriste mariage',
    title: 'Prix d’un fleuriste de mariage',
    card: 'Le prix du bouquet, des centres de table et de l’arche, et comment fleurir sans se ruiner.',
    seoTitle: 'Prix fleuriste mariage : budget fleurs, bouquet et centres de table · RSVP Please',
  },
  {
    slug: 'prix-salle-mariage',
    theme: 'budget',
    label: 'Prix salle de mariage',
    title: 'Prix d’une salle de mariage',
    card: 'Les tarifs selon le type de lieu, ce qui est compris, et les frais cachés du contrat.',
    seoTitle: 'Prix salle de mariage : tarifs de location et frais cachés · RSVP Please',
  },
  {
    slug: 'budget-mariage-excel',
    theme: 'budget',
    label: 'Budget mariage Excel',
    title: 'Budget mariage sur Excel : le modèle de tableau',
    card: 'Les colonnes, les postes et les formules à reproduire dans Excel ou Google Sheets.',
    seoTitle: 'Budget mariage Excel : modèle de tableau, postes et formules · RSVP Please',
  },

  // ---- Invitations en ligne ----
  {
    slug: 'site-mariage-gratuit',
    theme: 'invitations',
    label: 'Site de mariage gratuit',
    title: 'Créer un site de mariage gratuit en 15 minutes',
    card: 'Ce qu’il doit contenir, les étapes, et les pièges des sites « gratuits ».',
    seoTitle: 'Site de mariage gratuit : le créer en 15 minutes, sans publicité · RSVP Please',
  },
  {
    slug: 'faire-part-numerique-mariage',
    theme: 'invitations',
    label: 'Faire-part numérique',
    title: 'Faire-part de mariage numérique : le guide',
    card: 'Avantages, limites, comment l’envoyer et comment recueillir les réponses.',
    seoTitle: 'Faire-part de mariage numérique : guide, envoi et réponses en ligne · RSVP Please',
  },
  {
    slug: 'save-the-date-numerique',
    theme: 'invitations',
    label: 'Save the date numérique',
    title: 'Save the date numérique gratuit',
    card: 'Le faire, l’envoyer et ne rien oublier dedans, sans dépenser un euro.',
    seoTitle: 'Save the date numérique gratuit : le créer et l’envoyer · RSVP Please',
  },
  {
    slug: 'faire-part-mariage-whatsapp',
    theme: 'invitations',
    label: 'Faire-part par WhatsApp',
    title: 'Envoyer son faire-part de mariage par WhatsApp ou e-mail',
    card: 'Est-ce que ça se fait, pour qui, et comment éviter les réponses perdues.',
    seoTitle: 'Faire-part de mariage par WhatsApp ou e-mail : comment bien faire · RSVP Please',
  },
  {
    slug: 'mariage-deux-jours',
    theme: 'invitations',
    label: 'Mariage sur deux jours',
    title: 'Organiser un mariage sur deux jours',
    card: 'Les formules, qui inviter à quoi, le budget en plus et les textes pour l’annoncer.',
    seoTitle: 'Mariage sur deux jours : formules, invités, budget et textes · RSVP Please',
  },

  // ---- Textes et discours ----
  {
    slug: 'texte-faire-part-mariage',
    theme: 'textes',
    label: 'Texte faire-part',
    title: 'Texte de faire-part de mariage : 40 exemples à copier',
    card: 'Classiques, modernes, courts, avec enfants, avec cagnotte : le texte qu’il vous faut.',
    seoTitle: 'Texte faire-part mariage : 40 exemples à copier · RSVP Please',
  },
  {
    slug: 'texte-save-the-date',
    theme: 'textes',
    label: 'Texte save the date',
    title: 'Texte de save the date : exemples à copier',
    card: 'Des textes courts, drôles ou élégants pour annoncer la date.',
    seoTitle: 'Texte save the date mariage : exemples à copier · RSVP Please',
  },
  {
    slug: 'faire-part-mariage-humour',
    theme: 'textes',
    label: 'Faire-part humoristique',
    title: 'Faire-part de mariage humoristique : 30 textes drôles',
    card: 'Des textes qui font sourire sans faire oublier l’essentiel.',
    seoTitle: 'Faire-part mariage humour : 30 textes drôles à copier · RSVP Please',
  },
  {
    slug: 'texte-remerciement-mariage',
    theme: 'textes',
    label: 'Texte de remerciement',
    title: 'Texte de remerciement après le mariage',
    card: 'Plus de 30 textes à copier, du mot aux invités au discours des mariés.',
    seoTitle: 'Texte remerciement mariage : exemples pour invités et famille · RSVP Please',
  },
  {
    slug: 'discours-temoin-mariage',
    theme: 'textes',
    label: 'Discours de témoin',
    title: 'Discours de témoin de mariage : trame et exemples',
    card: 'La trame en 5 temps, quoi raconter et 4 exemples complets.',
    seoTitle: 'Discours témoin mariage : trame, conseils et exemples · RSVP Please',
  },

  // ---- Plan de table ----
  {
    slug: 'plan-de-table-mariage-original',
    theme: 'plan-de-table',
    label: 'Plan de table original',
    title: 'Plan de table original : 20 idées d’affichage',
    card: 'Miroir, cadres, cartes postales, plantes : des idées pour afficher le plan.',
    seoTitle: 'Plan de table mariage original : 20 idées d’affichage · RSVP Please',
  },
  {
    slug: 'table-honneur-mariage',
    theme: 'plan-de-table',
    label: 'Table d’honneur',
    title: 'Table d’honneur : qui placer, et où',
    card: 'Les formules possibles, qui s’y assoit, et les cas délicats.',
    seoTitle: 'Table d’honneur mariage : qui placer et comment la disposer · RSVP Please',
  },
  {
    slug: 'nom-de-table-mariage',
    theme: 'plan-de-table',
    label: 'Noms de tables',
    title: 'Noms de tables de mariage : 80 idées originales',
    card: 'Villes, films, vins, fleurs, souvenirs : 80 idées classées par thème.',
    seoTitle: 'Nom de table mariage original : 80 idées par thème · RSVP Please',
  },
  {
    slug: 'table-ronde-combien-de-personnes',
    theme: 'plan-de-table',
    label: 'Taille des tables rondes',
    title: 'Table ronde : combien de personnes par table ?',
    card: 'Le nombre de places selon le diamètre, et rondes ou rectangulaires.',
    seoTitle: 'Table ronde mariage : combien de personnes selon le diamètre · RSVP Please',
  },

  // ---- Réception et jour J ----
  {
    slug: 'vin-d-honneur-mariage',
    theme: 'jour-j',
    label: 'Vin d’honneur',
    title: 'Vin d’honneur : durée, quantités et animations',
    card: 'Combien de temps, combien de pièces et de bouteilles, et quoi prévoir.',
    seoTitle: 'Vin d’honneur mariage : durée, quantités, animations · RSVP Please',
  },
  {
    slug: 'menu-mariage',
    theme: 'jour-j',
    label: 'Menu de mariage',
    title: 'Menu de mariage : idées par saison et formules',
    card: 'Dîner assis, buffet, food trucks : des menus selon la saison et le budget.',
    seoTitle: 'Menu mariage : idées par saison, formules et conseils · RSVP Please',
  },
  {
    slug: 'planning-jour-j-mariage',
    theme: 'jour-j',
    label: 'Planning du jour J',
    title: 'Planning du jour J : le déroulé heure par heure',
    card: 'Un déroulé type, à adapter et à partager avec vos témoins et prestataires.',
    seoTitle: 'Planning jour J mariage : déroulé type heure par heure · RSVP Please',
  },
  {
    slug: 'animation-mariage-originale',
    theme: 'jour-j',
    label: 'Animations originales',
    title: 'Animations de mariage originales : 30 idées',
    card: 'Pour le vin d’honneur, le dîner, les enfants et la soirée.',
    seoTitle: 'Animation mariage originale : 30 idées pour chaque moment · RSVP Please',
  },
  {
    slug: 'brunch-lendemain-mariage',
    theme: 'jour-j',
    label: 'Brunch du lendemain',
    title: 'Brunch du lendemain de mariage : organisation et budget',
    card: 'Qui inviter, quoi servir, combien prévoir, et comment le gérer simplement.',
    seoTitle: 'Brunch lendemain mariage : organisation, menu et budget · RSVP Please',
  },
  {
    slug: 'kit-de-survie-mariage',
    theme: 'jour-j',
    label: 'Kit de survie',
    title: 'Kit de survie du mariage : la liste complète',
    card: 'Le kit des mariés, celui des invités et celui des toilettes, à cocher.',
    seoTitle: 'Kit de survie mariage : la liste complète à préparer · RSVP Please',
  },
  {
    slug: 'droit-de-bouchon-mariage',
    theme: 'jour-j',
    label: 'Droit de bouchon',
    title: 'Le droit de bouchon au mariage',
    card: 'Combien il coûte, ce qu’il couvre, quand il vaut le coup et comment le négocier.',
    seoTitle: 'Droit de bouchon mariage : prix, calcul et négociation · RSVP Please',
  },
  {
    slug: 'meilleur-mois-mariage',
    theme: 'preparer',
    label: 'Meilleur mois pour se marier',
    title: 'Quel est le meilleur mois pour se marier ?',
    card: 'Les mois préférés des couples selon l’INSEE, et ce que chaque saison change.',
    seoTitle: 'Meilleur mois pour se marier : chiffres INSEE et conseils · RSVP Please',
  },
  {
    slug: 'qui-paie-le-mariage',
    theme: 'budget',
    label: 'Qui paie le mariage',
    title: 'Qui paie le mariage ?',
    card: 'Tradition, usages d’aujourd’hui, façons de répartir et comment en parler en famille.',
    seoTitle: 'Qui paie le mariage ? Tradition, usages et répartition · RSVP Please',
  },
  {
    slug: 'combien-donner-mariage',
    theme: 'budget',
    label: 'Combien donner à un mariage',
    title: 'Combien donner à un mariage ?',
    card: 'Les repères selon votre lien avec les mariés, et quoi écrire dans la carte.',
    seoTitle: 'Combien donner à un mariage ? Repères et usages · RSVP Please',
  },
  {
    slug: 'invitation-vin-d-honneur-texte',
    theme: 'textes',
    label: 'Invitation au vin d’honneur',
    title: 'Invitation au vin d’honneur : 20 textes à copier',
    card: 'Classiques, décontractés, drôles ou pour les collègues, et le carton dîner.',
    seoTitle: 'Invitation vin d’honneur : 20 textes à copier · RSVP Please',
  },
  {
    slug: 'alternative-zankyou',
    theme: 'invitations',
    label: 'Alternative à Zankyou',
    title: 'Zankyou : ce qu’est devenu le site de mariage, et par quoi le remplacer',
    card: 'Le rachat, la redirection vers Mariages.net, et comment remplacer site et liste.',
    seoTitle: 'Zankyou site de mariage : ce qu’il est devenu et les alternatives · RSVP Please',
  },
  {
    slug: 'alternative-mariages-net',
    theme: 'invitations',
    label: 'Site de mariage Mariages.net',
    title: 'Site de mariage Mariages.net : ce qu’il propose et les alternatives',
    card: 'Ce qui est gratuit, ce qui est payant, les questions à se poser et les alternatives.',
    seoTitle: 'Site de mariage Mariages.net : avis, fonctions et alternatives · RSVP Please',
  },
  {
    slug: 'cocktail-signature-mariage',
    theme: 'jour-j',
    label: 'Cocktail signature',
    title: 'Cocktail signature de mariage : 10 recettes et les quantités',
    card: 'Choisir son cocktail, 10 recettes faciles, combien en prévoir et le servir sans barman.',
    seoTitle: 'Cocktail signature mariage : 10 recettes et quantités · RSVP Please',
  },
  {
    slug: 'texte-faire-part-religieux',
    theme: 'textes',
    label: 'Faire-part religieux',
    title: 'Texte de faire-part de mariage religieux : 16 exemples',
    card: 'Formules d’usage, ordre des cérémonies, textes par tradition et citations.',
    seoTitle: 'Texte faire-part mariage religieux : 16 exemples · RSVP Please',
  },
  {
    slug: 'faire-part-bilingue',
    theme: 'textes',
    label: 'Faire-part bilingue',
    title: 'Faire-part de mariage bilingue : mise en page et textes',
    card: 'Mises en page, pièges de traduction et textes en français et en anglais.',
    seoTitle: 'Faire-part mariage bilingue : mise en page et textes · RSVP Please',
  },
  {
    slug: 'texte-report-mariage',
    theme: 'textes',
    label: 'Report du mariage',
    title: 'Texte pour annoncer le report d’un mariage : exemples à copier',
    card: 'Dans quel ordre prévenir, quoi dire, et des textes de report ou d’annulation.',
    seoTitle: 'Texte report mariage : annoncer un report ou une annulation · RSVP Please',
  },
  {
    slug: 'adresse-site-mariage',
    theme: 'invitations',
    label: 'Adresse du site',
    title: 'Nom de domaine pour son mariage : choisir l’adresse de son site',
    card: 'Adresse gratuite ou nom de domaine, règles de choix, exemples et redirection.',
    seoTitle: 'Nom de domaine mariage : choisir l’adresse de son site · RSVP Please',
  },
  {
    slug: 'organiser-mariage-3-mois',
    theme: 'preparer',
    label: 'Mariage en 3 mois',
    title: 'Organiser son mariage en 3 mois : le plan semaine par semaine',
    card: 'Les choix qui rendent la chose possible, la mairie, et un plan sur 12 semaines.',
    seoTitle: 'Organiser un mariage en 3 mois : plan semaine par semaine · RSVP Please',
  },
  {
    slug: 'mariage-sans-enfants',
    theme: 'textes',
    label: 'Mariage sans enfants',
    title: 'Mariage sans enfants : comment le dire (textes à copier)',
    card: 'Où et quand le dire, des formulations bienveillantes, les exceptions et les réponses.',
    seoTitle: 'Mariage sans enfants : comment le dire, textes à copier · RSVP Please',
  },
  {
    slug: 'relancer-invites-mariage',
    theme: 'invitations',
    label: 'Relancer les invités',
    title: 'Relancer les invités d’un mariage : quand et comment, avec des messages',
    card: 'Le bon calendrier, le bon canal, des messages à copier et les cas délicats.',
    seoTitle: 'Relancer les invités d’un mariage : quand, comment, messages · RSVP Please',
  },
  {
    slug: 'plus-one-mariage',
    theme: 'preparer',
    label: 'Le « plus one »',
    title: 'Le « plus one » au mariage : qui inviter accompagné, et comment le dire',
    card: 'Qui y a droit, le coût pour le budget, comment l’écrire et comment refuser.',
    seoTitle: 'Plus one mariage : qui inviter accompagné et comment le dire · RSVP Please',
  },
  {
    slug: 'liste-b-invites-mariage',
    theme: 'preparer',
    label: 'La liste B',
    title: 'Liste B des invités de mariage : comment l’organiser sans vexer',
    card: 'La construire par priorité, le calendrier d’envoi et les règles de discrétion.',
    seoTitle: 'Liste B mariage : comment l’organiser sans vexer · RSVP Please',
  },
  {
    slug: 'allergies-invites-mariage',
    theme: 'jour-j',
    label: 'Allergies des invités',
    title: 'Allergies des invités au mariage : recueillir, transmettre, servir',
    card: 'Poser la question, prévenir le traiteur et éviter les erreurs le jour J.',
    seoTitle: 'Allergies des invités au mariage : la méthode complète · RSVP Please',
  },
  {
    slug: 'invite-annule-mariage',
    theme: 'plan-de-table',
    label: 'Invité qui annule',
    title: 'Un invité annule au mariage : que faire, selon le moment',
    card: 'Le traiteur, le plan de table, la liste B et la réponse à l’invité.',
    seoTitle: 'Invité qui annule au mariage : que faire selon le moment · RSVP Please',
  },
  {
    slug: 'hebergement-invites-mariage',
    theme: 'preparer',
    label: 'Hébergement des invités',
    title: 'Hébergement des invités au mariage : qui paie, solutions et bloc de chambres',
    card: 'Qui paie, les solutions, réserver un bloc de chambres et informer les invités.',
    seoTitle: 'Hébergement des invités au mariage : solutions et conseils · RSVP Please',
  },
  {
    slug: 'enfants-au-mariage',
    theme: 'jour-j',
    label: 'Enfants au mariage',
    title: 'Enfants au mariage : les occuper et organiser leur journée',
    card: 'Baby-sitters, espace enfants, repas, activités par âge et coin dodo.',
    seoTitle: 'Enfants au mariage : animation, baby-sitter et organisation · RSVP Please',
  },
  {
    slug: 'inviter-collegues-mariage',
    theme: 'preparer',
    label: 'Inviter ses collègues',
    title: 'Inviter ses collègues à son mariage : qui, comment, et le congé',
    card: 'Les trois options, le cas du manager, l’annonce au bureau et le congé mariage.',
    seoTitle: 'Inviter ses collègues à son mariage : qui et comment · RSVP Please',
  },
  {
    slug: 'parents-divorces-mariage',
    theme: 'plan-de-table',
    label: 'Parents divorcés',
    title: 'Parents divorcés au mariage : plan de table, faire-part et cérémonie',
    card: 'En parler avant, le faire-part, la cérémonie, les tables et les photos.',
    seoTitle: 'Parents divorcés au mariage : plan de table et conseils · RSVP Please',
  },
  {
    slug: 'que-mettre-site-mariage',
    theme: 'invitations',
    label: 'Que mettre sur son site',
    title: 'Que mettre sur son site de mariage : rubriques et exemples de textes',
    card: 'Les rubriques par ordre d’importance, des textes à adapter et ce qu’il faut éviter.',
    seoTitle: 'Que mettre sur son site de mariage : rubriques et textes · RSVP Please',
  },
  {
    slug: 'table-enfants-mariage',
    theme: 'plan-de-table',
    label: 'Table des enfants',
    title: 'Table des enfants au mariage : âge, placement et idées',
    card: 'Qui s’y assoit, où la placer, combien par table et quoi mettre dessus.',
    seoTitle: 'Table enfants mariage : âge, placement et idées · RSVP Please',
  },
];

export const articleByPath = (path: string) => ARTICLES.find((a) => `/${a.slug}` === path);
